export default __webpack_public_path__ + "static/media/vector1.5f6204b0.svg";